import React from "react";

import Card from "@busbud/design-system-components/dist/Card";
import Divider from "@busbud/design-system-components/dist/Divider";
import Skeleton from "@busbud/design-system-components/dist/Skeleton";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useStyles } from "./skeleton.styles";

interface Props {
  selected?: boolean;
}

export const SelectableCardSkeleton: React.FC<Props> = ({ selected }) => {
  const { cx, classes } = useStyles();

  return (
    <Card
      borderRadius="xl"
      boxShadow="md"
      p={2.5}
      className={cx({
        [classes.selected]: !!selected
      })}
      width="100%"
      data-testid="selectable-card-skeleton"
    >
      <Stack spacing={2} direction="column">
        <Stack justifyContent="space-between">
          <Stack spacing={1}>
            <Skeleton
              width={3}
              size="md"
              className={cx({ [classes.selectedSkeleton]: selected })}
            />
            <Skeleton
              width={15}
              size="md"
              variant="text"
              className={cx({ [classes.selectedSkeleton]: selected })}
            />
          </Stack>
          <Skeleton
            width={7}
            size="md"
            variant="text"
            className={cx({ [classes.selectedSkeleton]: selected })}
          />
        </Stack>
        <Divider className={classes.divider} />
        <Skeleton
          size="md"
          className={cx({ [classes.selectedSkeleton]: selected })}
        />
      </Stack>
    </Card>
  );
};
